import { SnackbarRequestObject } from "@/store/app/state";

export const defaultPhoneSnackbarErrorObjectItem: SnackbarRequestObject = {
  title: "snackbar.errors.defaultError.title",
  text: "snackbar.errors.defaultError.text",
};
